// extracted by mini-css-extract-plugin
module.exports = {"root":"Period_root__2NQSB"};